import { jsx as _jsx } from "react/jsx-runtime";
import * as React from 'react';
import * as ToggleGroupPrimitive from '@radix-ui/react-toggle-group';
import { cva } from 'class-variance-authority';
import { cn } from '../../lib/utils';
const toggleGroupVariants = cva('inline-flex items-center justify-center overflow-hidden', {
    variants: {
        variant: {
            default: 'bg-transparent',
            outline: 'border border-gray-200 dark:border-border bg-gray-50 dark:bg-muted rounded-md',
        },
        spacing: {
            default: 'gap-0',
            sm: 'gap-0',
            lg: 'gap-0',
        },
    },
    defaultVariants: {
        variant: 'default',
        spacing: 'default',
    },
});
const toggleGroupItemVariants = cva('inline-flex items-center justify-center gap-2 whitespace-nowrap font-medium transition-colors disabled:pointer-events-none disabled:opacity-50 focus:outline-none focus-visible:ring-2 focus-visible:ring-ring', {
    variants: {
        variant: {
            default: 'bg-muted text-muted-foreground hover:bg-background hover:text-foreground data-[state=on]:bg-primary data-[state=on]:text-primary-foreground data-[state=on]:shadow-sm',
            outline: 'bg-background text-muted-foreground border-r border-border last:border-r-0 hover:bg-muted hover:text-foreground data-[state=on]:bg-primary data-[state=on]:text-primary-foreground data-[state=on]:shadow-sm hover:data-[state=on]:bg-primary/90',
        },
        size: {
            default: 'h-9 px-3 text-sm',
            sm: 'h-7 px-2.5 text-xs',
            lg: 'h-10 px-4 text-sm',
        },
    },
    defaultVariants: {
        variant: 'default',
        size: 'default',
    },
});
const ToggleGroup = React.forwardRef(({ className, variant, spacing, ...props }, ref) => (_jsx(ToggleGroupPrimitive.Root, { ref: ref, className: cn(toggleGroupVariants({ variant, spacing }), className), ...props })));
ToggleGroup.displayName = ToggleGroupPrimitive.Root.displayName;
const ToggleGroupItem = React.forwardRef(({ className, variant, size, ...props }, ref) => (_jsx(ToggleGroupPrimitive.Item, { ref: ref, className: cn(toggleGroupItemVariants({ variant, size }), className), ...props })));
ToggleGroupItem.displayName = ToggleGroupPrimitive.Item.displayName;
export { ToggleGroup, ToggleGroupItem };
//# sourceMappingURL=toggle-group.js.map